import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Checkbox from "rc-checkbox";
import findIndex from "lodash/findIndex";
import { connect } from "react-redux";
import filter from "lodash/filter";
import {
  Card,
  CardBody,
  CardImg,
  Button,
  CardTitle,
  CardText,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import DashboardNotesItem from "./DashboardNotesItem";
import Loading from "../../../../../hoc/Loading/Loading";
import axios from "../../../../../axios";
import * as actionCreators from "../../../../../modules/actions/index";
import * as url from "../../../../../utils/url";
import LinkChart from "../../../../../assets/placeholders/dashboard_sample.png";
import {
  dashboardChartSize,
  uploadPreview,
} from "../../../../../utils/constants";
import NoKpiPlaceholder from "../../../../../assets/placeholders/no_kpi_available.svg";
import moment from "moment";
import noAttachments from "../../../../../assets/upload_file.svg";
import DeleteNotesConfirmationModal from "./DeleteNotesConfirmationModal";

class DashboardNotesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attachments: [],
      selectedDoc: null,
      deleteConfirmOpen: false,
    };
  }

  getUpload = () => {
    this.setState({ isUploadFiles: true });
  };

  uploadAttachments = () => {
    let { setImagesPreview, currentDashboard } = this.state;

    const formData = new FormData();

    if (setImagesPreview && setImagesPreview.length > 0) {
      Array.from(setImagesPreview).forEach((itm) => {
        formData.append("uploads", itm.file);
      });

      formData.append("_id", currentDashboard._id);
      // formData.append('isAttachments', task_copy.attachItems)

      let that = this;

      axios
        .post(url.dashboardUploadFiles, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          let result = data.data;
          delete result.createdBy;
          let new_item = { ...currentDashboard, ...result };
          that.props.updateReport(new_item);
          this.setState({
            isActionsModal: false,
            isResourceSelect: null,
            isUploadFiles: false,
            setImagesPreview: [],
          });
        });
    } else {
      this.setState({
        uploadFileErr: "No files to Upload",
      });
    }
  };

  toggleRemoveConfirm = (itm) => {
    this.setState({
      selectedDoc: itm,
      deleteConfirmOpen: true,
    });
  };

  closeRemoveConfirm = () => {
    this.setState({
      selectedDoc: null,
      deleteConfirmOpen: false,
    });
  };

  // componentDidMount(){
  //   console.log('---props: ', this.props)
  // }

  componentDidUpdate(prevProps) {
    let { attachments } = this.state;
    if (
      this.props.reports &&
      this.props.reports.attachments &&
      this.props.reports.attachments.length > 0
    ) {
      let current_att = this.props.reports.attachments.length;
      let prev_att = attachments.length;
      if (current_att != prev_att) {
        this.setState({
          attachments: this.props.reports.attachments,
        });
      }
    } else if (
      this.props.reports &&     this.props.reports.attachments && this.props.reports.attachments.length == 0 &&
      attachments.length > 0
    ) {
      this.setState({
        attachments: [],
      });
    }
  }

  removeUpoload = (itm) => {
    let { reports } = this.props;
    let { currentDashboard } = this.state;
    let { attachments } = this.state;
    let payload = {
      removeItm: itm,
      dashboardId: reports._id,
    };

    let res = attachments.filter((e) => e.url != itm);

    let new_item = { attachments: res };
    this.props.updateReport(new_item);

    axios.post(url.dashboardRemoveUploads, payload).then(({ data }) => {
      this.closeRemoveConfirm()
    });
  };

  fileSelectedHandler = (e) => {
    if (e.target.files) {
      let arr = [];
      let fileArr = Array.from(e.target.files).map((file, idx) => {
        let blob = URL.createObjectURL(file);
        let obj = {
          name: file.name,
          type: file.type,
          size: file.size,
          file,
          blob,
          preview: blob,
        };
        return uploadPreview(obj);
      });

      this.setState((prevState) => ({
        setImagesPreview: prevState.setImagesPreview.concat(fileArr),
      }));
      Array.from(e.target.files).map((file) => URL.revokeObjectURL(file));
    }
  };

  removeImage = (photo) => {
    let { setImagesPreview } = this.state;
    let { preview } = photo;
    setImagesPreview.map((el) => URL.revokeObjectURL(el.file));
    let result = setImagesPreview.filter((e) => e.preview != preview);
    URL.revokeObjectURL(preview);
    URL.revokeObjectURL(photo.file);
    this.setState({ setImagesPreview: result });
  };
  renderUploadPreview = (source) => {
    return source.map((photo, idx) => {
      let { preview, size } = photo;
      let mb = 1024 * 1024;
      let file_size =
        size >= mb
          ? `${(size / mb).toFixed(2)}mb`
          : `${(size / 1024).toFixed(2)}kb`;
      return (
        <span key={idx} className="taskUploadPreviewImg">
          <img src={preview} className="fileUploadSize" />
          <span
            key={preview + idx}
            onClick={() => this.removeImage(photo)}
            className="removeTaskUpload"
          >
            <span className="flaticon-trash" />
          </span>
          <div className="previewTaskImageText">
            <span className="previewTaskImageTitle">{photo.name}</span>
            <span className="previewTaskImageTitle">{file_size}</span>
          </div>
        </span>
      );
    });
  };
  handleClick = (event) => {
    const { target = {} } = event || {};
    target.value = "";
  };
  openUploadModal = () => {
    this.props.updateReport({ isUploadFiles: true });
  };
  closeUploadFile = () => {
    this.setState({ isUploadFiles: false });
  };

  renderView = () => {
    let { attachments } = this.state;
    let { userCanEdit } = this.props.reports;

    if (attachments && attachments.length > 0) {
      return attachments.map((e) => {
        let { size, url } = e;
        let img = uploadPreview(e);
        let { preview, isMsIcon } = img;
        let mb = 1024 * 1024;
        let file_size =
          size >= mb
            ? `${(size / mb).toFixed(2)}mb`
            : `${(size / 1024).toFixed(2)}kb`;

        return (
          <div className="col-lg-3" key={url}>
            <Card className="taskAttachmentItmContainer">
              <span className="taskAttachmentImgContainer"   style={{ padding: '8px 5px' }} >
                <CardImg
                  alt="..."
                  src={preview}
                  top
                  className="taskAttachmentImg"
                  style={{ height: isMsIcon ? "100%" : null }}
                />
                {/* {img.blob?
                    <div classaName="imageUploadBlobSrc">
                        <iframe src={img.blob} class="imgBlobSrc" scrolling="no" scroll="no" />
                    </div>
                  :
                  <CardImg
                    alt="..."
                    src={preview}
                    top
                    className="taskAttachmentImg"
                    style={{'height': isMsIcon?'5vw': null}}
                  /> } */}
              </span>
              <CardBody className="uploadTaskContainer">
                <CardTitle className="taskAttachmentName">{e.name}</CardTitle>
                <CardText className="ml0">
                  <span className="taskAttachmentContent">
                    <a href={e.url} target="_blank">
                      Download
                    </a>{" "}
                    ({file_size})
                  </span>
                  {userCanEdit ? (
                    <span
                      className="taskRemoveAttachment"
                      onClick={() => this.toggleRemoveConfirm(e.url)}
                    >
                      Remove
                      <span className="flaticon-trash" />
                    </span>
                  ) : null}
                  <span className="taskAttachmentContent text-muted">
                    Uploaded on {moment(e.uploadDate).format("MMM D, YYYY")}
                  </span>
                </CardText>
              </CardBody>
            </Card>
          </div>
        );
      });
    } else {
      return (
        <div className="dashboardNoUploadsContainer">
          <img src={noAttachments} className="taskNoLinkedCharts" />
          <span className="dashboardNoUploadTxt">
            There are currently no reports/notes on this dashboard. Depending on
            your access rights, you may upload any external file type -
            csv/excel, image, pdf, powerpoint, word document, etc - to this
            action to track progress, share thoughts, and more.
            {userCanEdit ? (
              <span>
                Click on the <strong>Upload Files</strong> button above or{" "}
                <span
                  className="clickHere"
                  onClick={() => this.openUploadModal()}
                >
                  here
                </span>
                .
              </span>
            ) : null}
          </span>
        </div>
      );
    }
  };

  render() {
    return this.props.reports.hideCharts ? (
      <div className="card-deck taskAttachmentContainer col-md-12 col-lg-12 col-sm-12">
        {this.state.selectedDoc && this.state.deleteConfirmOpen ? (
          <DeleteNotesConfirmationModal
            open={this.state.deleteConfirmOpen}
            onDelete={() => this.removeUpoload(this.state.selectedDoc)}
            closeModal={() => this.closeRemoveConfirm()}
          />
        ) : (
          ""
        )}

        {this.renderView()}
      </div>
    ) : null;
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onKpiMasterListFetched: (data) =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: (dashboard) =>
      dispatch(actionCreators.updateReport(dashboard)),
  };
};

// export default LinkedCharts;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(DashboardNotesList, axios)));
